import { useState } from "react";
import { toast } from "sonner";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useApp } from "@/context/AppContext";
import { api, errMsg } from "@/lib/api";

export function BulkAssignBar({ kind, ids, onClear, onDone }) {
  const { options } = useApp();
  const [busy, setBusy] = useState(false);
  if (!ids.length) return null;
  const assign = async (destination) => {
    setBusy(true);
    try {
      const r = await api.post("/bulk/section", { kind, ids, destination });
      toast.success(`${r.data.updated} record${r.data.updated === 1 ? "" : "s"} assigned to ${destination}`);
      onClear();
      onDone();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="sticky top-20 z-20 mt-4 flex flex-wrap items-center gap-3 rounded-xl border border-[hsl(var(--gold))] bg-white p-3 shadow-lg" data-testid="bulk-assign-bar">
      <span className="font-semibold text-slate-900" data-testid="bulk-selected-count">{ids.length} selected</span>
      <span className="text-sm text-slate-500">Assign all to:</span>
      {options.destinations.filter((d) => d.active).map((d) => (
        <Button key={d.name} size="sm" disabled={busy} onClick={() => assign(d.name)} data-testid={`bulk-assign-${d.name.toLowerCase().replace(/\s+/g, "-")}`}>{d.name}</Button>
      ))}
      <Button size="sm" variant="ghost" onClick={onClear} className="ml-auto" data-testid="bulk-clear"><X className="mr-1 h-4 w-4" /> Clear</Button>
    </div>
  );
}

export function SelectBox({ checked, onChange, testid, label }) {
  return <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} aria-label={label} className="h-4 w-4 cursor-pointer accent-[hsl(var(--primary))]" data-testid={testid} />;
}
